// extracted by mini-css-extract-plugin
export default {"rubikContainer":"Rubik_rubikContainer__6BYid","rubikWrapper":"Rubik_rubikWrapper__4pdgP","rubikSide":"Rubik_rubikSide__uPqi6","buttonsWrapper":"Rubik_buttonsWrapper__THDC1"};